(function() {
    'use strict';

    angular
        .module('atheer')
        .constant('paginationConstants', {
            'itemsPerPage': 10
        });
})();
